async function fundebugLoad({ vue, fundebugKey, environment = "production" }) {
  if (process.env.NODE_ENV === environment) {
    const fundebug = await import("fundebug-javascript");
    const FundebugVue = (await import("fundebug-vue")).default;
    try {
      fundebug.init({
        apikey: fundebugKey || "1e85e830db718b3448c5f34620ff06d8d9d6d4bf65d9b7cb317d5faadd88783b",
        sampleRate: 1,
        filters: [
          {
            message: /^ResizeObserver/
          },
          {
            message: /Cannot use import statement outside a module/
          }
        ]
      });
      new FundebugVue(fundebug).installVueErrorHandler(vue);
      await import('fundebug-revideo');
    } catch (error) {
      console.log("[fundebug error] ", error);
    }
  }
}

export default fundebugLoad;